export default "<app-header></app-header>\n<router-outlet></router-outlet>\n<footer class=\"fixed-bottom\"></footer>\n"